import { BaseAction } from "../../../core/actions/BaseAction";
import { SHUTTLE_PRODUCT_CODE } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { ILeg, IOffer, ITrip, ITripOfferModel } from "../../../Orchestrator/Types/Index";

export interface IProps {
  trips: ITrip[],
  offers: IOffer[]
}

export class GetTripOfferModalFromOffersAction extends BaseAction<ITripOfferModel[], IProps> {
  override async run(): Promise<ITripOfferModel[]> {
    const tripOffers: ITripOfferModel[] = [];
    try {
      const { trips, offers } = this.params!

      for (const trip of trips) {

        const standardOffer = offers.find(offer =>
          offer.tripCoverage?.coveredTripId === trip.id &&
          offer.products[0].code === "SFC"
        );

        const shuttleOffer = offers.find(offer =>
          offer.tripCoverage?.coveredTripId === trip.id &&
          offer.products[0].code === SHUTTLE_PRODUCT_CODE
        );

        const standardProOffer = offers.find(offer =>
          offer.tripCoverage?.coveredTripId === trip.id &&
          offer.products[0].code === "SFF"
        );

        const premiumOffer = offers.find(offer =>
          offer.tripCoverage?.coveredTripId === trip.id &&
          offer.products[0].code === "PFF"
        );

        if (trip?.legs?.length > 0) {
          trip.legs = trip?.legs?.map((leg: ILeg) => {
            const legOffers: IOffer[] | undefined = offers.filter(offer => offer?.tripCoverage?.coveredTripId === trip.id && offer.tripCoverage?.coveredLegIds?.includes(leg.id));
            if (legOffers) {
              leg.legOffer = [...legOffers];
            }
            return leg;
          })
        }

        tripOffers.push({
          trip,
          standardOffer,
          standardProOffer,
          premiumOffer,
          shuttleOffer
        });
      }

    }
    catch (error) { }
    finally { return tripOffers }
  }
}

export const getTripOfferModalFromOffersAction = new GetTripOfferModalFromOffersAction();
